import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f8f5393a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f8f5393a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f5393a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f5393a')) {
      api.createRecord('f8f5393a', component.options)
    } else {
      api.reload('f8f5393a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f8f5393a&scoped=true&", function () {
      api.rerender('f8f5393a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BUqyg5wWuhI0/JS/comp/DocBox.vue"
export default component.exports